// Booking destination helpers.
//
// TasWater/Intimap bookings can carry multiple destinations in
// metadata.various_destination (array of {address, latitude, longitude}).
// Older bookings and other companies only have metadata.address (string).
// Display code should prefer the full list when it exists, since
// metadata.address may hold only the first destination on old bookings.
//
// Addresses are joined with "; " — addresses themselves contain commas
// ("East Wagga Wagga, NSW"), so a comma separator is ambiguous.

export const DESTINATION_SEPARATOR = "; ";

export function parseBookingMetadata(metadata) {
  if (!metadata) return null;
  if (typeof metadata === "string") {
    try {
      return JSON.parse(metadata);
    } catch (e) {
      return null;
    }
  }
  return typeof metadata === "object" ? metadata : null;
}

export function getVariousDestinationList(metadata) {
  const parsed = parseBookingMetadata(metadata);
  if (!parsed || !Array.isArray(parsed.various_destination)) return [];
  return parsed.various_destination
    .map(dest => (dest && dest.address ? dest.address : ""))
    .filter(Boolean);
}

export function getVariousDestinationText(metadata, maxItems) {
  const list = getVariousDestinationList(metadata);
  if (!list.length) return "";
  if (maxItems && list.length > maxItems) {
    const shown = list.slice(0, maxItems).join(DESTINATION_SEPARATOR);
    return `${shown} (+${list.length - maxItems} more)`;
  }
  return list.join(DESTINATION_SEPARATOR);
}

// Returns the display text for a booking's destination address:
// the joined various_destination list when present, otherwise metadata.address.
// Pass maxItems to cap how many addresses are shown (for table cells);
// omit it for detail views that should show everything.
export function getBookingDestinationText(metadata, maxItems) {
  const various = getVariousDestinationText(metadata, maxItems);
  if (various) return various;
  const parsed = parseBookingMetadata(metadata);
  return parsed && parsed.address ? parsed.address : "";
}
